import Skeleton from 'src/Admin/components/common/skeleton';
import SelectedItemComponent from './SelectedItemComponent';

const ProviderSideModal = ({
  data,
  setSelectedProviderData,
  skeletonLoader,
  isServerError,
  setProviderListData,
  dataFetching,
}) => {
  const onChangeHandler = (e) => {
    const { id } = e.target;
    console.log('debug_perOnChange', id, data);
    const updatedItems = data?.map((item) =>
      item?.PhysicainOid + '_' + item?.FacilityOid === id
        ? { ...item, isChecked: true }
        : { ...item, isChecked: false },
    );
    setProviderListData(updatedItems);
    console.log(
      'debug_afterOnChange',
      updatedItems?.find((item) => item?.PhysicainOid === id),
      updatedItems,
      data,
    );
  };

  return (
    <div>
      <div className="provider-side-panel-disclaimer">
        {dataFetching ? (
          <div className="pr-4">
            <Skeleton count={1} height={30} />
          </div>
        ) : data?.length && !isServerError ? (
          <>
            <>
              Found {data?.length} Result{data?.length > 1 && `s`}
            </>
            <hr />
          </>
        ) : null}
      </div>

      <div className="reports-modal-devider" />
      <div className="blob-lists physician">
        {!dataFetching && !(isServerError || !data.length) ? (
          data?.map((item, index) => (
            <div className="physician-list-item" key={index}>
              <SelectedItemComponent
                onChangeHandler={onChangeHandler}
                item={item}
              />
            </div>
          ))
        ) : dataFetching ? (
          <Skeleton count={15} height={30} />
        ) : isServerError && !data.length ? (
          <div className="more-spl pt-3">
            No results found! We could not find any Provider with the values
            that you have entered. Try again using other values.
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default ProviderSideModal;
